/* Greedsweeper - Custom Minesweeper Game */

class Greedsweeper {
  constructor() {
    this.rows = 10;
    this.cols = 10;
    this.totalDevils = 15;
    this.board = [];
    this.revealed = [];
    this.flagged = [];
    this.gameOver = false;
    this.moneyCollected = 0;
    this.gameWindow = null;
  }

  init() {
    this.createBoard();
    this.calculateNumbers();
    this.renderGame();
  }

  createBoard() {
    // Initialize empty board
    this.board = Array(this.rows).fill(null).map(() => Array(this.cols).fill(0));
    this.revealed = Array(this.rows).fill(null).map(() => Array(this.cols).fill(false));
    this.flagged = Array(this.rows).fill(null).map(() => Array(this.cols).fill(false));

    // Place devils randomly
    let devilsPlaced = 0;
    while (devilsPlaced < this.totalDevils) {
      const row = Math.floor(Math.random() * this.rows);
      const col = Math.floor(Math.random() * this.cols);
      
      if (this.board[row][col] !== '😈') {
        this.board[row][col] = '😈';
        devilsPlaced++;
      }
    }
  }

  calculateNumbers() {
    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        if (this.board[row][col] === '😈') continue;
        
        let count = 0;
        // Check all 8 neighbors
        for (let dr = -1; dr <= 1; dr++) {
          for (let dc = -1; dc <= 1; dc++) {
            if (dr === 0 && dc === 0) continue;
            const newRow = row + dr;
            const newCol = col + dc;
            
            if (newRow >= 0 && newRow < this.rows && newCol >= 0 && newCol < this.cols) {
              if (this.board[newRow][newCol] === '😈') {
                count++;
              }
            }
          }
        }
        this.board[row][col] = count;
      }
    }
  }

  revealCell(row, col) {
    if (this.gameOver || this.revealed[row][col] || this.flagged[row][col]) return;

    this.revealed[row][col] = true;

    // Hit a devil!
    if (this.board[row][col] === '😈') {
      this.gameOver = true;
      this.revealAll();
      this.showGameOver();
      return;
    }

    // Collect money
    this.moneyCollected++;
    this.updateMoneyCounter();

    // If empty cell (0), reveal neighbors
    if (this.board[row][col] === 0) {
      for (let dr = -1; dr <= 1; dr++) {
        for (let dc = -1; dc <= 1; dc++) {
          const newRow = row + dr;
          const newCol = col + dc;
          
          if (newRow >= 0 && newRow < this.rows && newCol >= 0 && newCol < this.cols) {
            this.revealCell(newRow, newCol);
          }
        }
      }
    }

    this.renderGame();
    this.checkWin();
  }

  toggleFlag(row, col) {
    if (this.gameOver || this.revealed[row][col]) return;
    
    this.flagged[row][col] = !this.flagged[row][col];
    this.renderGame();
  }

  revealAll() {
    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        this.revealed[row][col] = true;
      }
    }
    this.renderGame();
  }

  checkWin() {
    let safeCells = (this.rows * this.cols) - this.totalDevils;
    let revealedSafe = 0;

    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        if (this.revealed[row][col] && this.board[row][col] !== '😈') {
          revealedSafe++;
        }
      }
    }

    if (revealedSafe === safeCells) {
      this.gameOver = true;
      this.showWin();
    }
  }

  renderGame() {
    const gameBoard = document.getElementById('greedsweeper-board');
    if (!gameBoard) return;

    gameBoard.innerHTML = '';
    gameBoard.style.display = 'grid';
gameBoard.style.gridTemplateColumns = `repeat(${this.cols}, 20px)`;
gameBoard.style.gap = '1px';
gameBoard.style.backgroundColor = '#808080';
gameBoard.style.padding = '4px';
gameBoard.style.border = '2px inset #808080';
gameBoard.style.margin = '0 auto';
gameBoard.style.width = 'fit-content';

    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        const cell = document.createElement('div');
        cell.className = 'greedy-cell';
        cell.style.width = '20px';
        cell.style.height = '20px';
        cell.style.display = 'flex';
        cell.style.alignItems = 'center';
        cell.style.justifyContent = 'center';
        cell.style.fontSize = '12px';
        cell.style.fontWeight = 'bold';
        cell.style.cursor = 'pointer';
        cell.style.userSelect = 'none';

        if (this.revealed[row][col]) {
          cell.style.background = '#c0c0c0';
          cell.style.border = '1px solid #808080';
          
          const value = this.board[row][col];
          if (value === '😈') {
            cell.textContent = '😈';
            cell.style.background = '#ff0000';
          } else if (value === 0) {
            cell.textContent = '';
          } else {
            cell.textContent = '$'.repeat(value);
            cell.style.color = this.getNumberColor(value);
            cell.style.fontSize = '10px';
          }
        } else if (this.flagged[row][col]) {
          cell.style.background = '#c0c0c0';
          cell.style.border = '2px solid';
          cell.style.borderColor = '#dfdfdf #808080 #808080 #dfdfdf';
          cell.textContent = '🚩';
        } else {
          cell.style.background = '#c0c0c0';
          cell.style.border = '2px solid';
          cell.style.borderColor = '#dfdfdf #808080 #808080 #dfdfdf';
        }

        // Left click to reveal
        cell.addEventListener('click', () => {
          if (!this.gameOver && !this.flagged[row][col]) {
            this.revealCell(row, col);
          }
        });

        // Right click to flag
        cell.addEventListener('contextmenu', (e) => {
          e.preventDefault();
          this.toggleFlag(row, col);
        });

        gameBoard.appendChild(cell);
      }
    }
  }

  getNumberColor(num) {
    const colors = {
      1: '#0000ff',
      2: '#008000',
      3: '#ff0000',
      4: '#000080',
      5: '#800000',
      6: '#008080',
      7: '#000000',
      8: '#808080'
    };
    return colors[num] || '#000000';
  }

  updateMoneyCounter() {
    const counter = document.getElementById('money-counter');
    if (counter) {
      counter.textContent = `$${this.moneyCollected}`;
    }
  }

  showGameOver() {
    const statusMsg = document.querySelector('[data-game-status]');
    if (statusMsg) {
      statusMsg.textContent = '😈 OOPS! THE GREED TOOK OVER! 😈';
      statusMsg.style.color = '#ff0000';
      statusMsg.style.fontWeight = 'bold';
    }
  }

  showWin() {
    const statusMsg = document.querySelector('[data-game-status]');
    if (statusMsg) {
      statusMsg.textContent = `💰 You won! Collected $${this.moneyCollected}! 💰`;
      statusMsg.style.color = '#008000';
      statusMsg.style.fontWeight = 'bold';
    }
  }

  reset() {
    this.gameOver = false;
    this.moneyCollected = 0;
    this.createBoard();
    this.calculateNumbers();
    this.renderGame();
    this.updateMoneyCounter();
    
    const statusMsg = document.querySelector('[data-game-status]');
    if (statusMsg) {
      statusMsg.textContent = 'Click to collect money! Right-click to flag devils.';
      statusMsg.style.color = '#000000';
      statusMsg.style.fontWeight = 'normal';
    }
  }

  openGameWindow() {
    // Check if window already exists
    if (this.gameWindow && document.body.contains(this.gameWindow)) {
      window.Windows95Desktop.bringToFront(this.gameWindow);
      return;
    }

    const gameWindow = document.createElement('div');
    gameWindow.className = 'win95-window active';
    gameWindow.id = 'greedsweeper-window';
    gameWindow.style.width = '280px';
    gameWindow.style.maxWidth = '90vw';

    gameWindow.innerHTML = `
      <div class="win95-title-bar">
        <div class="win95-title-text">
          <span>💰</span>
          Greedsweeper
        </div>
        <div class="win95-window-controls">
          <button class="win95-btn win95-btn-minimize" aria-label="Minimize"></button>
          <button class="win95-btn win95-btn-close" aria-label="Close"></button>
        </div>
      </div>
      <div class="win95-window-content" style="padding: 12px; max-height: 80vh; overflow-y: auto;">
        <div style="display: flex; justify-content: space-between; margin-bottom: 12px; padding: 8px; background: #c0c0c0; border: 2px inset #808080;">
          <div style="font-size: 12px; font-weight: bold;">
            Money: <span id="money-counter">$0</span>
          </div>
          <div style="font-size: 12px; font-weight: bold;">
            Devils: ${this.totalDevils}
          </div>
        </div>

        <div id="greedsweeper-board"></div>

        <div style="margin-top: 12px; padding: 8px; background: #ffffff; border: 2px inset #808080; font-size: 11px; text-align: center;" data-game-status>
          Click to collect money! Right-click to flag devils.
        </div>

        <div style="margin-top: 12px; display: flex; justify-content: center; gap: 8px;">
          <button class="win95-button win95-button-primary" id="reset-game">
            New Game
          </button>
          <button class="win95-button" id="close-game">
            Close
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(gameWindow);
    this.gameWindow = gameWindow;

    // Setup window controls
    const closeBtn = gameWindow.querySelector('.win95-btn-close');
    const minimizeBtn = gameWindow.querySelector('.win95-btn-minimize');
    const closeGameBtn = gameWindow.querySelector('#close-game');
    const resetBtn = gameWindow.querySelector('#reset-game');

    const closeWindow = () => {
      gameWindow.remove();
      this.gameWindow = null;
    };

    closeBtn?.addEventListener('click', closeWindow);
    minimizeBtn?.addEventListener('click', closeWindow);
    closeGameBtn?.addEventListener('click', closeWindow);
    resetBtn?.addEventListener('click', () => this.reset());

    // Make draggable and center
    window.Windows95Desktop.makeDraggable(gameWindow);
    window.Windows95Desktop.centerWindow(gameWindow);

    // Initialize game
    this.init();
  }
}

// Global instance
window.greedsweeper = new Greedsweeper();

// Listen for game open event
document.addEventListener('win95-open-greedsweeper', () => {
  window.greedsweeper.openGameWindow();
});